import { createGlobalStyle } from 'styled-components'

const PromoGlobalStyles = createGlobalStyle`
  #promo-container table {
    display: table !important;
    width: 100% !important;
    font-family: 'Inter', sans-serif;
    /* color: white; */
    /* background-color: transparent; */
    border-spacing: 0;
    border-collapse: collapse;
  }

  #promo-container td, 
  #promo-container th {
    padding: 8px;
    /* color: white; */
    font-size: 14px;
    vertical-align: top;
  }

  #promo-container p {
    margin-top: 0;
    margin-bottom: 16px;
    line-height: 1.6;
    font-size: 15px;
    /* color: white; */
  }

  #promo-container h1,
  #promo-container h2,
  #promo-container h3,
  #promo-container h4,
  #promo-container h5,
  #promo-container h6 {
    /* color: white; */
    margin: 0 0 16px;
  }


  #promo-container a {
    color: #4fd1c5;
    text-decoration: none;
  }

  #promo-container ul {
    padding-left: 20px;
    margin-bottom: 16px;
  }

  #promo-container img {
    max-width: 100%;
    border-radius: 8px;
  }

  #promo-container .captionImage {
    width: 100%!important;
    object-fit: contain;
    height: 304px;
  }

  #promo-container .GET_IT_NOW_CLASS_FOR_WEBPLAYER {
    color: #000 !important;
    padding: 12px 24px;
    font-weight: bold;
    border-radius: 8px;
    font-size: 16px;
    text-align: center;
  }

  #promo-container tr {
  display: table-row !important;
}

#promo-container td {
  display: table-cell !important;
  vertical-align: middle;
  text-align: center;
  padding: 4px;
}

#promo-container td[style*="text-align:center"] {
  display: flex !important;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

#promo-container td[style*="text-align:center"] a {
  display: inline-block !important;
  margin-right: 0 !important; 
}

  /* #promo-container #bodyTable,
  #promo-container #emailContainer {
    background-color: transparent !important;
  } */
`

export default PromoGlobalStyles
